import { PersonType } from './person-type.model';
import { PaymentType, CoverType } from '../../enums';

export class ContractType {
  postalCode: string;
  province: string;
  noOfPerson: string;
  policyHolder: PersonType[]=[];
  paymetType: PaymentType;
  policyStartRealDate: any;
  phone: string;
  emailAddress: string;
  coverType: CoverType;
  isAdvertisement: boolean;
  extraInfo: string;
}
